import clientAxios from "../config";

const getCombos = (token, params = {}) =>
    clientAxios('/api/combos', {
        params,
        headers: { Authorization: `Bearer ${token}` },
    });

const createCombo = (token, payload) =>
    clientAxios.post('/api/combos', payload, {
        headers: { Authorization: `Bearer ${token}` },
    });

const updateCombo = (token, comboId, payload) =>
    clientAxios.put(`/api/combos/${comboId}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
    });

const deleteCombo = (token, comboId) =>
    clientAxios.delete(`/api/combos/${comboId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });

export {
    getCombos,
    createCombo,
    updateCombo,
    deleteCombo
}